import React from "react";
import "../styles/BenefitsShowcase.css";

function BenefitsShowcase() {
  const benefits = [
    {
      id: 1,
      subtitle: "Invest with Confidence – Secure & Hassle-Free",
      title: "Easy, Safe & Secure",
      description: "We ensure bank-grade security and a user-friendly platform, so your investments remain protected and seamless at every step. Whether you're buying or selling, we guarantee a trusted and smooth transaction experience.",
      tags: ["Safe Transactions", "Seamless Experience", "Bank-Grade Security"],
      illustration: "security",
      imagePosition: "left"
    },
    {
      id: 2,
      subtitle: "Stay in Control – Track Every Step in Real-Time",
      title: "Real-Time Tracking",
      description: "No more guesswork! Our intuitive dashboard provides live status updates on every stage of your investment—from inquiry to share transfer—ensuring complete transparency.",
      tags: ["Live Updates", "Full Transparency", "Instant Notifications"],
      illustration: "tracking",
      imagePosition: "right"
    },
    {
      id: 3,
      subtitle: "Trade Unlisted Shares with One Click",
      title: "Buy & Sell Directly from the Portal",
      description: "No intermediaries, no extra hassle! Our platform lets you buy and sell shares instantly, giving you direct access to exclusive pre-IPO investments anytime, anywhere.",
      tags: ["Easy Investing", "Direct Access", "No Middlemen"],
      illustration: "trading",
      imagePosition: "left"
    }
  ];

  const renderIllustration = (type) => {
    switch(type) {
      case "security":
        return (
          <div className="security-stage">
            <svg className="security-radar security-radar-1" viewBox="0 0 200 200">
              <circle cx="100" cy="100" r="90" fill="none" stroke="url(#radarGradient1)" strokeWidth="2"/>
            </svg>
            <svg className="security-radar security-radar-2" viewBox="0 0 200 200">
              <circle cx="100" cy="100" r="70" fill="none" stroke="url(#radarGradient2)" strokeWidth="2"/>
            </svg>
            <svg className="security-radar security-radar-3" viewBox="0 0 200 200">
              <circle cx="100" cy="100" r="50" fill="none" stroke="url(#radarGradient3)" strokeWidth="2"/>
            </svg>
            
            <div className="security-shield-core">
              <svg className="security-shield-icon" width="80" height="80" viewBox="0 0 24 24" fill="none">
                <defs>
                  <linearGradient id="radarGradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="rgba(59, 130, 246, 0.4)" />
                    <stop offset="100%" stopColor="rgba(59, 130, 246, 0.1)" />
                  </linearGradient>
                  <linearGradient id="radarGradient2" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="rgba(59, 130, 246, 0.5)" />
                    <stop offset="100%" stopColor="rgba(59, 130, 246, 0.2)" />
                  </linearGradient>
                  <linearGradient id="radarGradient3" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="rgba(59, 130, 246, 0.6)" />
                    <stop offset="100%" stopColor="rgba(59, 130, 246, 0.3)" />
                  </linearGradient>
                  <linearGradient id="shieldGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#60a5fa" />
                    <stop offset="100%" stopColor="#3b82f6" />
                  </linearGradient>
                </defs>
                <path 
                  className="security-shield-body"
                  d="M12 2L4 5V11C4 16.55 7.84 21.74 12 23C16.16 21.74 20 16.55 20 11V5L12 2Z" 
                  fill="url(#shieldGradient)"
                />
                <path 
                  className="security-shield-check"
                  d="M10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z" 
                  fill="#0f172a"
                />
              </svg>
              <div className="security-glow-inner"></div>
            </div>
            
            <div className="security-particle security-particle-1"></div>
            <div className="security-particle security-particle-2"></div>
            <div className="security-particle security-particle-3"></div>
            <div className="security-particle security-particle-4"></div>
            
            <div className="security-scan-line"></div>
          </div>
        );
        case "tracking":
        return (
          <div className="status-feed-container">
            <div className="status-pulse-card status-pulse-first">
              <div className="status-indicator status-indicator-check">
                <svg className="status-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <div className="status-text-block">
                <div className="status-heading">Shares request approved</div>
                <div className="status-timestamp">1:01 PM, Thursday</div>
              </div>
              <div className="status-glow-effect"></div>
            </div>
            
            <div className="status-pulse-card status-pulse-second">
              <div className="status-indicator status-indicator-success">
                <svg className="status-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <div className="status-text-block">
                <div className="status-heading">Shares Successfully Transferred</div>
                <div className="status-timestamp">30 min ago</div>
              </div>
              <div className="status-glow-effect"></div>
            </div>
          </div>
        );
      // case "tracking":
      //   return (
      //     <div className="status-feed-container">
      //       <div className="status-pulse-card status-pulse-first">
      //         <div className="status-indicator status-indicator-check">
      //           <svg className="status-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      //             <polyline points="20 6 9 17 4 12"></polyline>
      //           </svg>
      //         </div>
      //         <div className="status-text-block">
      //           <div className="status-heading">Shares request approved</div>
      //           <div className="status-timestamp">1:01 PM, Thursday</div>
      //         </div>
      //         <div className="status-glow-effect"></div>
      //       </div>
            
      //       <div className="status-pulse-card status-pulse-second">
      //         <div className="status-indicator status-indicator-success">
      //           <svg className="status-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      //             <polyline points="20 6 9 17 4 12"></polyline>
      //           </svg>
      //         </div>
      //         <div className="status-text-block">
      //           <div className="status-heading">Shares Successfully Transferred</div>
      //           <div className="status-timestamp">30 min ago</div>
      //         </div>
      //         <div className="status-glow-effect"></div>
      //       </div>
      //     </div>
      //   );
      case "trading":
        return (
          <div className="trade-scene-wrapper">
            <div className="trade-card-float">
              <div className="trade-stock-badge">
                <div className="trade-avatar-pulse"></div>
                <div className="trade-stock-label">Unlisted Stock</div>
              </div>
              <div className="trade-info-lines">
                <div className="trade-line-full"></div>
                <div className="trade-line-half"></div>
              </div>
              <div className="trade-action-row">
                <button className="trade-btn-sell">
                  <span className="trade-btn-text">SELL</span>
                  <div className="trade-btn-ripple"></div>
                </button>
                <button className="trade-btn-buy">
                  <span className="trade-btn-text">BUY</span>
                  <div className="trade-btn-ripple"></div>
                </button>
              </div>
              <div className="trade-cursor-animate"></div>
            </div>
            <div className="trade-glow-orb trade-glow-red"></div>
            <div className="trade-glow-orb trade-glow-green"></div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="benefits-showcase">
      <div className="showcase-header">
        <h2 className="showcase-title">Built for Investors – Secure, Fast & Transparent</h2>
        <p className="showcase-subtitle">
          Invest in unlisted shares with confidence—seamless, safe, and fully trackable.
        </p>
      </div>

      <div className="benefits-container">
        {benefits.map((benefit) => (
          <div 
            key={benefit.id} 
            className={`benefit-row ${benefit.imagePosition === "right" ? "reverse" : ""}`}
          >
            <div className="benefit-illustration">
              {renderIllustration(benefit.illustration)}
            </div>

            <div className="benefit-content">
              <p className="benefit-subtitle">{benefit.subtitle}</p>
              <h3 className="benefit-title">{benefit.title}</h3>
              <p className="benefit-description">{benefit.description}</p>
              <div className="benefit-tags">
                {benefit.tags.map((tag, index) => (
                  <span key={index} className="benefit-tag">{tag}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BenefitsShowcase;